// Historical-import CSV format (distinct from bank-export OFX/QFX):
// date,checkNum,payee,description,fund,category,amount,group
//   amount is signed — negative = expense, positive = income
//   group is optional: rows sharing the same non-empty group value are one
//   split transaction (e.g. one check paying both "Grounds"/Church and
//   Food Cupboard) and become a single Firestore doc with multiple `lines`.
//   Statement month always defaults to the month of `date` at import time —
//   reassigning a transaction to a different statement period happens in
//   the Reconcile view, not here.

const parseCsvLine = (line) => {
  const fields = [];
  let cur = '';
  let inQuotes = false;
  for (let i = 0; i < line.length; i++) {
    const ch = line[i];
    if (inQuotes) {
      if (ch === '"') {
        if (line[i + 1] === '"') { cur += '"'; i++; } else { inQuotes = false; }
      } else {
        cur += ch;
      }
    } else if (ch === '"') {
      inQuotes = true;
    } else if (ch === ',') {
      fields.push(cur);
      cur = '';
    } else {
      cur += ch;
    }
  }
  fields.push(cur);
  return fields.map(f => f.trim());
};

// Returns [{ date, checkNum, payee, description, importId, lines: [{ fund, category, amount }] }]
export const parseCsvTransactions = (text) => {
  const rawLines = text.split(/\r\n|\n|\r/).filter(l => l.trim() !== '');
  if (rawLines.length === 0) return [];

  const header = parseCsvLine(rawLines[0]).map(h => h.toLowerCase());
  const idx = (name) => header.indexOf(name);
  const iDate = idx('date'), iCheck = idx('checknum'), iPayee = idx('payee'),
        iDesc = idx('description'), iFund = idx('fund'), iCat = idx('category'),
        iAmt = idx('amount'), iGroup = idx('group');

  const groups = new Map(); // groupKey -> { date, checkNum, payee, description, lines: [] }

  rawLines.slice(1).forEach((line, i) => {
    const f = parseCsvLine(line);
    const date = f[iDate];
    if (!date) return;
    const checkNum = (iCheck >= 0 ? f[iCheck] : '') || '';
    const payee = (iPayee >= 0 ? f[iPayee] : '') || '';
    const description = (iDesc >= 0 ? f[iDesc] : '') || '';
    const fund = f[iFund] || '';
    const category = f[iCat] || '';
    const amount = parseFloat(f[iAmt]) || 0;
    const groupRaw = (iGroup >= 0 ? f[iGroup] : '') || '';
    const key = groupRaw ? `g:${groupRaw}` : `single:${i}`;

    if (!groups.has(key)) {
      groups.set(key, { date, checkNum, payee, description, lines: [] });
    }
    groups.get(key).lines.push({ fund, category, amount });
  });

  return Array.from(groups.entries()).map(([key, tx]) => ({
    ...tx,
    importId: `csv-${tx.date}-${tx.checkNum || 'nc'}-${key}`,
  }));
};
